import { ValidatorFn, Validators } from '@angular/forms';

// Mirrors the backend's password rules exactly (src/auth/dto/register.dto.ts
// in ghoulpool-api) so client-side validation never disagrees with the server.
const MIN_PASSWORD_LEN = 8;
const MAX_PASSWORD_LEN = 72;
const PASSWORD_STRENGTH_RE = /^(?=.*[A-Za-z])(?=.*\d).+$/;

export const passwordValidators: ValidatorFn[] = [
  Validators.required,
  Validators.minLength(MIN_PASSWORD_LEN),
  Validators.maxLength(MAX_PASSWORD_LEN),
  Validators.pattern(PASSWORD_STRENGTH_RE),
];
